<template>
  <login-layout
    @opened="opened"
    :title="title">
    <!-- initial options -->
    <login-options
      v-if="tab=='options'"
      :loading.sync="loading"
      :initial-email="email"
      @checked="emailChecked">
    </login-options>
    <!-- basic authentication -->
    <login-basic
      v-if="tab=='basic'"
      :email="email"
      :exists="emailExists"
      @reset="resetPassword"
      @canceled="canceled">
    </login-basic>
    <!-- reset pasword -->
    <reset-password
      v-if="tab==='reset_password'"
      :email="email"
      :exists="emailExists"
      @canceled="canceled">
    </reset-password>
    <!-- register user -->
    <register-user
      v-if="tab==='register_user'"
      :email="email"
      :exists="emailExists"
      :auto-verified="autoVerified"
      @canceled="canceled">
    </register-user>
  </login-layout>
</template>

<script>

import LoginLayout from '@/components/Auth/LoginLayout.vue';
import LoginOptions from '@/components/Auth/LoginOptions.vue';
import LoginBasic from '@/components/Auth/LoginBasic.vue';
import ResetPassword from '@/components/Auth/ResetPassword.vue';
import RegisterUser from '@/components/Auth/RegisterUser.vue';

import providerController from '@/controllers/Provider';

export default {
  name: 'LoginModal',
  data() {
    return {
      loading: false,
      tab: 'options',
      email: null,
      emailExists: false,
      autoVerified: false,
    };
  },
  computed: {
    title() {
      let title = 'Iniciar sesión';
      if (this.tab === 'reset_password') {
        title = 'Nueva contraseña';
      }
      if (this.tab === 'register_user') {
        title = 'Crear usuario';
      }
      return title;
    },
  },
  methods: {
    async opened() {
      this.loading = true;
      try {
        // reset initial variables
        this.tab = 'options';
        this.email = null;
        this.emailExists = false;
        this.autoVerified = false;
        // check if login is opened from provider site
        // and if exists the "code" query string param
        const { name, query } = this.$route;
        if (name === 'providersite' && query?.code) {
          // get provider by code
          const response = await providerController.searchByCode(query.code);
          const provider = response.data;
          this.email = provider.email;
          this.autoVerified = true;
        }
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    emailChecked(response) {
      this.email = response.email;
      this.emailExists = response.exists;
      if (this.emailExists) {
        this.tab = 'basic';
      } else {
        this.tab = 'register_user';
      }
    },
    resetPassword() {
      this.tab = 'reset_password';
    },
    canceled() {
      const { tab } = this;
      if (tab === 'basic' || tab === 'register_user') {
        this.tab = 'options';
      }
      if (tab === 'reset_password') {
        this.tab = 'basic';
      }
    },
  },
  components: {
    LoginLayout,
    LoginOptions,
    LoginBasic,
    ResetPassword,
    RegisterUser,
  },
};
</script>
